import { Component, OnInit } from '@angular/core';
import { ViewChild,ViewChildren,ElementRef } from '@angular/core';
import {  IStoreMenu, StoreService } from '../../services/store.service';
import { ItemBrandServiceService } from '../../services/item-brand-service.service';
import { MenuService } from '../../services/menu.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ItemService } from '../../services/item.service';
import { Input } from '@angular/core';
import { TranslationService } from 'src/app/shared/services/translation.service';
//import { TranslateService } from '@ngx-translate/core';

interface SelectedSub{
  subCategory: string;
  name: string;
  id: string;
  itemId: string}
@Component({
    selector: 'app-menu-nav',
    templateUrl: './app-menu-nav.component.html',
    styleUrls: ['./app-menu-nav.component.scss'],
    standalone: false
})
export class AppMenuNavComponent implements OnInit {
  @ViewChildren('accordionDescription') accordionDescription: any;
  @ViewChildren('add') add: any;
  @ViewChild('header') header: ElementRef;
  @ViewChild('overlay') overlay: ElementRef;
  @ViewChild ('navigation') navigation: ElementRef;
  @Input() storeName: string;
  @Input() scrollTracker: number;
  @Input() menu: IStoreMenu;
  x=0
  clicked: boolean=false;
  @Input() navOpen: boolean;
  
  //@Input() order: IOrder;
  @Input() cart: number;
  selectedSub: SelectedSub[]=[];
  @Input() location: string;
  constructor(
    //public translateService: TranslateService,
    public menuService: MenuService,
    public itemBrandService: ItemBrandServiceService,
    private storeService: StoreService,
    public itemService: ItemService,
    public settingService: SettingService,
    public translationService: TranslationService
  ) { 

  }

    get scroll()
    { 
        if(this.header)
      {
         let header=this.header.nativeElement;
          if(this.scrollTracker>=80 && this.clicked==false)
          { 
            header.classList.remove('hide');
            return ;
          }      
          else 
          {
            header.classList.add('hide');
            return;
          }
      
      }
  
    }
  ngOnInit() {
    let count=0;
    this.settingService.retailItems = this.settingService.configuration.retailItems;
   
    if(this.settingService.retailItems)
    {
      this.menuService.menu.storeMenuCategories.map(category=>{
        category.storeMenuCategoryItems.map(item=>{
          if(item.item.isRetailItem)
          {
            count++;
          }
        })
      })
    }

    if(count>0)
    {
      this.menuService.isStoreRetail=true;
    }
}

  
  filterNav()
  {
    this.x= window.innerWidth;
    this.storeService.toggleNav=true;
    if(this.overlay && this.navigation)
    { 
      let overlay=this.overlay.nativeElement;
      overlay.classList.remove('hide');
      let secondNav=this.navigation.nativeElement;

      this.clicked=true;
      if(this.x<992)
      {  secondNav.classList.add('open');
        setTimeout(() => {
          secondNav.classList.add('active-open');
        }, 100);
      }
      else
      {  secondNav.classList.add('open2');
  
        setTimeout(() => {
          if(this.settingService.navToggle)
          {
            secondNav.classList.add('active-open-screen2');
          }
          else
          {
            secondNav.classList.add('active-open-screen'); 
          }
           
        }, 100);
      }
    }
  }  
  
  

  close(e: any)
      {
          if(e.target.className=="nav-container")
          {
            this.closeNav();
          }
      }


  closeNav()
  { 
    this.storeService.toggleNav=false;
    if(this.overlay && this.navigation)
    {
      let secondNav=this.navigation.nativeElement;
    
        secondNav.classList.remove('active-open-screen');
        secondNav.classList.remove('active-open-screen2');
        secondNav.classList.remove('active-open');
      
      setTimeout(() => {
        this.clicked=false;
        let overlay=this.overlay.nativeElement;
        overlay.classList.add('hide');
      }, 300);

    }
    
  }
  
  selectedSubCategory(e: any,id= null)
  {  
   
  if(e.target.getAttribute('data-name'))
    { 
      let target=e.target as Element;
      let description="";
      target.classList.toggle('selected');
    
      if(target.className.includes('selected'))
      { 
        this.selectedSub.push({subCategory: target.innerHTML,name: e.target.getAttribute('data-name'), id: e.target.id, itemId: id})
        //target.innerHTML.slice(20)
      }
      else
      {
        this.selectedSub=this.selectedSub.filter(item=>item.id!==target.id)
      }
      this.sortMenu();

      for(let i=0; i<this.selectedSub.length; i++)
      {
        if(e.target.getAttribute('data-name')==this.selectedSub[i].name)
        {
          description=this.selectedSub[i].subCategory+", "+description;
        }
      }

      let accordionDescription=this.accordionDescription._results;
    
      for(let i=0;i<accordionDescription.length;i++)
      { 

        if(accordionDescription[i].nativeElement.getAttribute('data-name')==e.target.getAttribute('data-name'))
        { 
          accordionDescription[i].nativeElement.innerHTML=description.slice(0,-2);
        }
 
      }
  }
}

sortMenu()
{
  let arr=[];
  let items=[];
  this.menuService.menu.storeMenuCategories.map(category=>{
    category.storeMenuCategoryItems.map(item=>{
      items.push(item.item);
      item.subItems.map(subItem=>{
        items.push(subItem);
      })
  });
});
  arr=this.sortedCriteria(items);
  arr=this.getUniqueValues(arr);//this is to have an array with unique item id
  this.menuService.sortedMenu=[...arr];
}

  sortedCriteria(items)
  {
    //color,size,departments are covered here
    let arr=[];
    this.selectedSub.map((cat: SelectedSub)=>{
        items.map(item=>{
          if(item.itemBrandId==cat.id)
          {
            arr.push(item);
          }

          item.itemDepartments.map(department=>{
              if(cat.id==department.id)
              {
                   arr.push(item);
              }
          })
          
          item.itemColors.map(color=>{
            if(color.name.translations[localStorage['lang']] != undefined)
            {
  
              if(color.name.translations[localStorage['lang']].toLowerCase()==cat.subCategory.toLowerCase())
              {
                arr.push(item);
              }
            }
          })


          item.itemSizes.map(size=>{
          
          if(size.abbreviation.translations[localStorage['lang']] != undefined)
          {
            if(size.abbreviation.translations[localStorage['lang']].toLowerCase()==cat.subCategory.toLowerCase())
            {
              arr.push(item);
            }  
          }
          })

          item.itemSubCategories.map(subCategory=>{
            if(subCategory.id==cat.id)
            {
              arr.push(item);
            }
          })

        })
     });
    return arr;
  }

  getUniqueValues(arr)
  {
    let arrId=[];
    let result=[];
    for(let i=0;i<arr.length;i++)
    {
      for(let j=0;j<arr.length;j++)
      {
          if(!arrId.includes(arr[i].id))
          {
            arrId.push(arr[i].id);
            result.push(arr[i]);
          }
        }
      }
    return result;
  }

  selectedCategory(e: Event)
  { 
    let target=e.target as Element;
    target.classList.toggle('selected');
  }
  clickSpan(e: any)
  {
    if(e.target)
    {
      e.target.parentElement.classList.toggle('openAccordion');
      e.target.parentElement.classList.toggle("active");
      var panel = e.target.parentElement.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = (20+panel.scrollHeight) + "px";
      }
    }
  }
  iconToggle(name: any)
  { 
    let icon=this.add._results
    for(let i=0;i<icon.length;i++)
    {
      if(icon[i].nativeElement.getAttribute('data-name')==name)
      {
        icon[i].nativeElement.classList.toggle('active-icon');
      }
    }
  }
  accordionToggle(name: any)
  { 
    let accordionDescription=this.accordionDescription._results;
    for(let i=0;i<this.accordionDescription.length;i++)
    {
      if(accordionDescription[i].nativeElement.getAttribute('data-name')==name)
      {
        accordionDescription[i].nativeElement.classList.toggle('hide');
      }
    }
  }
openAccordion(e: any)
{ 
    if(e.target)
  { 
     e.target.classList.toggle('openAccordion');
     this.accordionToggle(e.target.getAttribute('data-name'));
     this.iconToggle(e.target.getAttribute('data-name'));
    var panel = e.target.nextElementSibling;
    if(panel)
    {
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = (20+panel.scrollHeight) + "px";
      } 
    }
  }   
    
}

}
